'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIcofont = require('react-icofont');

var _reactIcofont2 = _interopRequireDefault(_reactIcofont);

var _Constants = require('../Constants');

var Constants = _interopRequireWildcard(_Constants);

var _Utility = require('../../utils/Utility');

var Utility = _interopRequireWildcard(_Utility);

var _CartStore = require('../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _ScheduleScreenStore = require('../../stores/ScheduleScreenStore');

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _RestaurantInfoModal = require('../common/RestaurantInfoModal');

var _RestaurantInfoModal2 = _interopRequireDefault(_RestaurantInfoModal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LocationDetail = function (_React$Component) {
	_inherits(LocationDetail, _React$Component);

	function LocationDetail(props) {
		_classCallCheck(this, LocationDetail);

		var _this = _possibleConstructorReturn(this, (LocationDetail.__proto__ || Object.getPrototypeOf(LocationDetail)).call(this, props));

		_this.isValid = function (openHours, current) {

			var day = current.getDay();
			var shortDayStr = Utility.getDayShort(day).toUpperCase();

			return openHours[shortDayStr] && openHours[shortDayStr].toUpperCase() != 'CLOSED';
		};

		_this.state = {
			locationData: {},
			websiteConfig: {},
			showOpenHoursView: false,
			orderType: Constants.PICKUP,
			isDineInEnabled: false,
			scheduleDateTime: "",
			isNavBarScrolled: false,
			announcementNotificationEnabled: false,
			announcementMessage: "",
			showRestaurantInfoModal: false
		};
		_this._bind('renderSlider', 'handleShowModal', 'handleHideModal');
		return _this;
	}

	_createClass(LocationDetail, [{
		key: '_bind',
		value: function _bind() {
			var _this2 = this;

			for (var _len = arguments.length, methods = Array(_len), _key = 0; _key < _len; _key++) {
				methods[_key] = arguments[_key];
			}

			methods.forEach(function (method) {
				return _this2[method] = _this2[method].bind(_this2);
			});
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var defaultOrderType = _CartStore2.default.getOrderType();
			var scheduleDateTime = _ScheduleScreenStore2.default.getScheduledDate();

			if (!Utility.isEmptyObj(this.props.locationData)) {
				this.setState({
					locationData: this.props.locationData,
					websiteConfig: this.props.websiteConfig,
					orderType: defaultOrderType,
					scheduleDateTime: scheduleDateTime
				});
			}

			// listen to schedule screen store changes
			// this.subscribe = ScheduleScreenStore.listen(this.onScheduleStoreChange);

			this.announcementMessageReload();
		}

		// componentWillUnmount() {
		// 	// this.subscribe();
		// }

	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			var _this3 = this;

			if (this.props.locationData !== nextProps.locationData) {

				var defaultOrderType = _CartStore2.default.getOrderType();
				var scheduleDateTime = _ScheduleScreenStore2.default.getScheduledDate();

				this.setState({
					locationData: nextProps.locationData,
					websiteConfig: nextProps.websiteConfig,
					orderType: defaultOrderType,
					scheduleDateTime: scheduleDateTime
				}, function () {
					// Utils.hideSpinner();
					_this3.announcementMessageReload();
				});
			}
		}
	}, {
		key: 'handleShowModal',
		value: function handleShowModal() {
			this.setState({
				showRestaurantInfoModal: true
			});
		}
	}, {
		key: 'handleHideModal',
		value: function handleHideModal(status) {
			this.setState({
				showRestaurantInfoModal: false
			});
		}
	}, {
		key: 'getOpeningHoursComponent',
		value: function getOpeningHoursComponent() {

			if (Utility.isEmptyObj(this.state.locationData)) {
				return null;
			}

			var headerBar = this.state.locationData;

			// get date time based on the location
			var dateTime = _MainStore2.default.getCurrentDateTime();

			var todaysOpeningHour = Utility.filter(headerBar.openHours, function (key) {
				var today = Utility.getCurrentDayShort(dateTime);
				return today.toUpperCase() === key.toUpperCase();
			});

			var todaysOpenTimings = todaysOpeningHour[Utility.getCurrentDayShort(dateTime).toUpperCase()];

			if (todaysOpenTimings) {
				var timeRanges = todaysOpenTimings.split("|");

				var individualHours = timeRanges.map(function (timeRange) {
					return timeRange.split("-").map(function (time) {
						return Utility.parseTime(time, dateTime);
					});
				});

				var opening = individualHours.filter(function (individualHour) {

					// const today = new Date();
					// get date time based on the location
					var today = _MainStore2.default.getCurrentDateTime();

					return individualHour[0] <= today && today <= individualHour[1];
				}).map(function (individualHour) {
					return individualHour;
				});

				var openHoursStatus = "";
				var openHoursBtnLabel = "";
				if (opening.length === 0) {

					var openHoursTime = this.getNextOpenHours();

					if (openHoursTime != null) {
						var OpenTime = Utility.formatDateToHours(openHoursTime, dateTime);

						openHoursStatus = "CLOSED NOW";
						openHoursBtnLabel = "Opens " + OpenTime;
					} else {
						openHoursStatus = "TEMPORARILY";
						openHoursBtnLabel = "CLOSED";
					}
				} else {
					var CloseTime = Utility.dateToHours(opening[0][1]);

					openHoursStatus = "OPEN";
					openHoursBtnLabel = "Closes " + CloseTime;
				}

				return _react2.default.createElement(
					_react2.default.Fragment,
					null,
					_react2.default.createElement(
						'span',
						{ onClick: this.handleShowModal },
						_react2.default.createElement(
							'a',
							{
								className: "text-white",
								role: 'button',
								href: "#",
								onClick: function onClick(event) {
									return event.preventDefault();
								},
								tabIndex: 7
							},
							_react2.default.createElement(
								'u',
								{ className: 'cursor-pointer font-weight-bold ml-1' },
								openHoursBtnLabel
							)
						),
						_react2.default.createElement(
							'span',
							{ className: 'ml-1 badge badge-success cursor-pointer' },
							openHoursStatus
						)
					)
				);
			}
		}
	}, {
		key: 'getNextOpenHours',
		value: function getNextOpenHours() {

			var headerBar = this.state.locationData;
			var openHours = headerBar.openHours;
			// get date time based on the location
			var currentDateTime = _MainStore2.default.getCurrentDateTime();

			var weeklyOpenHoursLength = 7;

			var idx = 0;
			while (idx < weeklyOpenHoursLength) {
				var currentDay = _MainStore2.default.getCurrentDateTime();
				currentDay.setDate(currentDay.getDate() + idx);

				if (this.isValid(openHours, currentDay)) {

					var selectedDateTimings = Utility.getOpeningHoursOfGivenDate(openHours, currentDay);

					var individualHours = Utility.getIndividualHours(selectedDateTimings, currentDay);

					var hoursLen = individualHours.length;
					var key = 0;

					while (key < hoursLen) {
						var date1 = individualHours[key][0];
						// let date2 = individualHours[key][1];
						if (currentDateTime < date1) {
							return date1;
							break;
						}
						key++;
					}
				}
				idx++;
			}

			return null;
		}
	}, {
		key: 'getStartDateTime',
		value: function getStartDateTime() {
			var activeLocation = _MainStore2.default.getActiveLocation();
			if (!Utility.isEmptyObj(activeLocation) && !Utility.isEmptyObj(activeLocation.announcementConfig)) {

				if (!Utility.isEmptyObj(activeLocation.announcementConfig.startTime)) {

					var startDateStr = activeLocation.announcementConfig.startTime.iso;

					if (Utility.isEmpty(startDateStr)) {
						return null;
					}

					var startDate = new Date(startDateStr);

					var timeZone = _MainStore2.default.getLocationTimeZone();

					if (!Utility.isEmpty(timeZone)) {

						// change local date time based on the location timezone
						var locationStartTime = Utility.changeTimezone(startDate, timeZone);

						// return the location date time
						return locationStartTime;
					} else {

						// return the location date time
						return null;
					}
				} else {
					return null;
				}
			} else {
				return null;
			}
		}
	}, {
		key: 'getEndDateTime',
		value: function getEndDateTime() {
			var activeLocation = _MainStore2.default.getActiveLocation();

			if (!Utility.isEmptyObj(activeLocation) && !Utility.isEmptyObj(activeLocation.announcementConfig)) {

				if (!Utility.isEmptyObj(activeLocation.announcementConfig.endTime)) {

					var endDateStr = activeLocation.announcementConfig.endTime.iso;

					if (Utility.isEmpty(endDateStr)) {
						return null;
					}

					var endTime = new Date(endDateStr);
					// get selected location timezone
					var timeZone = _MainStore2.default.getLocationTimeZone();

					if (!Utility.isEmpty(timeZone)) {

						// change local date time based on the location timezone
						var locationEndTime = Utility.changeTimezone(endTime, timeZone);

						// return the location date time
						return locationEndTime;
					} else {

						// return the location date time
						return null;
					}
				} else {
					return null;
				}
			} else {
				return null;
			}
		}
	}, {
		key: 'announcementMessageReload',
		value: function announcementMessageReload() {

			var activeLocation = _MainStore2.default.getActiveLocation();

			this.setState({
				announcementNotificationEnabled: false,
				announcementMessage: ""
			});

			if (!Utility.isEmptyObj(activeLocation) && !Utility.isEmptyObj(activeLocation.announcementConfig)) {

				if (!Utility.isEmpty(activeLocation.announcementConfig.message)) {
					var message = activeLocation.announcementConfig.message;

					var startDate = this.getStartDateTime();
					var endDate = this.getEndDateTime();

					if (startDate != null && endDate != null) {
						var currentDate = _MainStore2.default.getCurrentDateTime();
						if (currentDate >= startDate && currentDate <= endDate) {
							this.setState({
								announcementNotificationEnabled: true,
								announcementMessage: message
							});
						} else {
							this.setState({
								announcementNotificationEnabled: false,
								announcementMessage: ""
							});
						}
					} else {
						this.setState({
							announcementNotificationEnabled: false,
							announcementMessage: ""
						});
					}
				} else {
					this.setState({
						announcementNotificationEnabled: false,
						announcementMessage: ""
					});
				}
			}
		}
	}, {
		key: 'renderSlider',
		value: function renderSlider() {

			var locationData = this.state.locationData;
			var mediaArr = locationData.mediaArray || [];

			var url = "";

			if (mediaArr.length > 0) {
				url = mediaArr[0].url;
			}

			return _react2.default.createElement(
				'div',
				{ className: "text-center" },
				_react2.default.createElement('img', {
					src: url,
					alt: 'HomeScreen',
					className: 'd-block w-100 cover img-fluid'
				})
			);
		}
	}, {
		key: 'render',


		// for banner slider
		// let slideClass = "carousel text-center";
		// if (mediaArr.length > 1) {
		// 	slideClass = "carousel slide text-center";
		// }

		// 	return (
		// 		<div id="carouselExampleControls" className={slideClass} data-ride="carousel">
		// 			<div className="carousel-inner">
		// 				{
		// 					mediaArr.map((media, index) => {
		// 						let classNameMedia2 = index === 0 ? "carousel-item active" : "carousel-item";
		//
		// 						return (
		// 							<div className={classNameMedia2} key = {`cim${index}`}>
		// 								<img
		// 									src       = {media.url}
		// 									alt       = {`HomeScreen${index}`}
		// 									className = "d-block w-100 cover img-fluid"
		// 								/>
		// 							</div>
		// 						);
		// 					})
		// 				}
		// 			</div>
		// 			<a className="carousel-control-prev" href="#carouselExampleControls" role="button"
		// 			   data-slide="prev">
		// 				<span className="carousel-control-prev-icon" aria-hidden="true"></span>
		// 				<span className="sr-only">Previous</span>
		// 			</a>
		// 			<a className="carousel-control-next" href="#carouselExampleControls" role="button"
		// 			   data-slide="next">
		// 				<span className="carousel-control-next-icon" aria-hidden="true"></span>
		// 				<span className="sr-only">Next</span>
		// 			</a>
		// 		</div>
		// 	)
		// };


		value: function render() {

			var locationData = this.state.locationData;
			var websiteConfig = this.state.websiteConfig;
			var phoneNumber = "";
			var phoneNumberDailing = "";
			var address = "";
			var locContainerOvd = {};
			var locbarType = "";
			var renderableLocBarComp = null;
			var locationName = "";
			var mediaArray = [];

			var hideChangeBtn = _MainStore2.default.hideChangeLocationBtn();

			if (!Utility.isEmptyObj(locationData) && typeof locationData.mediaArray !== 'undefined' && locationData.mediaArray.length > 0) {
				// the array is defined and has at least one element
				mediaArray = locationData.mediaArray;
			}

			var imageURL = "";
			if (mediaArray.length > 0) {
				imageURL = mediaArray[0].url;
			}

			if (!Utility.isEmptyObj(locationData)) {
				// Location name
				locationName = locationData.name;
				var addressString1 = locationData.addLine1;
				// Address
				var addressString2 = locationData.city + ', ' + locationData.state + ' ' + locationData.zipCode;
				address = addressString1.toUpperCase() + ", " + addressString2.toUpperCase();
			}

			var restaurantInfoColMd = "col-md-12";
			if (this.state.announcementNotificationEnabled) {
				restaurantInfoColMd = "col-md-8";
			}

			return _react2.default.createElement(
				'section',
				{ className: 'restaurant-detailed-banner' },
				this.renderSlider(),
				this.state.showRestaurantInfoModal ? _react2.default.createElement(_RestaurantInfoModal2.default, {
					callBackParent: this.handleHideModal
				}) : null,
				_react2.default.createElement(
					'div',
					{ className: 'restaurant-detailed-header', id: "res-header" },
					_react2.default.createElement(
						'div',
						{ className: "container" },
						_react2.default.createElement(
							'div',
							{ className: 'row d-flex align-items-end' },
							_react2.default.createElement(
								'div',
								{ className: restaurantInfoColMd },
								_react2.default.createElement(
									'div',
									{ className: 'restaurant-detailed-header-left' },
									_react2.default.createElement(
										'h2',
										{ className: 'text-white' },
										locationName
									),
									_react2.default.createElement(
										'p',
										{ className: 'text-white mb-1' },
										_react2.default.createElement(_reactIcofont2.default, { icon: 'location-pin' }),
										_react2.default.createElement(
											'span',
											{ className: "ml-1" },
											address
										)
									),
									_react2.default.createElement(
										'p',
										{ className: 'text-white mb-0' },
										_react2.default.createElement(_reactIcofont2.default, { icon: 'clock-time' }),
										this.getOpeningHoursComponent()
									)
								)
							),
							this.state.announcementNotificationEnabled ? _react2.default.createElement(
								'div',
								{ className: "col-md-4" },
								_react2.default.createElement(
									'div',
									{ className: 'restaurant-detailed-header-right' },
									_react2.default.createElement(
										'div',
										{ className: 'alert alert-info mb-0 d-flex ', role: 'alert' },
										_react2.default.createElement('i', { className: 'fa fa-bullhorn mr-2 d-inline-block ' }),
										_react2.default.createElement('span', { className: 'mb-0 d-inline-block',
											dangerouslySetInnerHTML: { __html: this.state.announcementMessage }
										})
									)
								)
							) : null
						)
					)
				)
			);
		}
	}]);

	return LocationDetail;
}(_react2.default.Component);

exports.default = LocationDetail;


//////////////////
// WEBPACK FOOTER
// ./src/components/home/LocationDetail.jsx
// module id = 541
// module chunks = 0